var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'w-90 d-flex justify-start chapter-content align-center pa-3 mx-3 border-radius-0 mb-2 ' +
        (_vm.active ? 'chapter-active' : 'chapter-text'),on:{"click":_vm.setChapter}},[_c('span',[_vm._v(_vm._s(_vm.$t('bookReading.chapter'))+" "+_vm._s(_vm.chapter_data.chapterNumber)+". "+_vm._s(_vm.chapter_data.chapterTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }